import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import AlertError from "../../../../../common/components/alert_error"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import { BancoPagamento } from "../../../domain/models/banco_pagamento"
import { Link as LinkTo } from 'react-router';
import { GenerateSaldoBancarioListaColumns } from "./columns"
import { useSaldoBancarioListaViewModel } from "../../viewModels/saldo_bancario_lista_view_model"
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal"
import { SaldoBancarioReportModal } from "./components/saldo_bancario_report_modal"
import { Header } from "./components/header"


export const SaldoBancarioLista = () => {

    const viewModel = useSaldoBancarioListaViewModel();

    const columnsDef = useMemo(() => {
        return GenerateSaldoBancarioListaColumns({
            onActionEdit: viewModel.handleSaldoBancarioEdit,
            onActionExportar: viewModel.openSaldoBancarioReportModal,

        });
    }, [
        viewModel.openSaldoBancarioReportModal,
        viewModel.handleSaldoBancarioEdit,
    ]);


    return (
        <>
            {/* <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleNewBancoPagamento()}>
                                    Novo Banco
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar> */}

            <div className="flex w-full gap-2 flex-col md:p-4 px-5 pt-2">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Typography className="text-primary-green">
                        Saldo Bancário
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Saldo Bancário</h1>
                        <p>Pesquisa de dados Cadastrais</p>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>


                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                status={viewModel.filters.status}
                                ddlBancoPagamento={viewModel.ddlBancoPagamento}
                                selectedIdsBancoPagamento={viewModel.filters.idsBancoPagamento ?? []}
                                onStatusChange={viewModel.handleStatusChange}
                                onClearFilters={viewModel.handleClearFilters}
                                handleIdsBancoPagamentoChange={viewModel.handleIdsBancoPagamentoChange}

                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">

                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="saldo_bancario_lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: BancoPagamento) => row.idBancoPagamento}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.bancoPagamentoLista}
                                    rowCount={viewModel.bancoPagamentoLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        right: ['idBancoPagamento'],
                                    }}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>

                            <ReportViewerModal
                                reportViewerState={viewModel.reportViewerState}
                            />

                            <SaldoBancarioReportModal
                                open={viewModel.saldoBancarioReportModalOpen}
                                saving={viewModel.saving}
                                selectedIdBancoPagamento={viewModel.selectedIdBancoPagamentoRelatorio ?? 0}
                                onClose={() => viewModel.openSaldoBancarioReportModal(null, false)}
                                onSubmit={viewModel.handleSaldoBancarioReportModalSubmit}
                            />

                        </>
                    )
                }

            </div >
        </>
    )
}
